import intl from 'react-intl-universal';
import MuiToolbar from '@mui/material/Toolbar';

import { Plugin, Template, TemplateConnector } from '@devexpress/dx-react-core';

import { Box } from '@mui/material';
import { generateNumberOfCardsMessage } from '@/utils/ListViewUtil.ts';

const useStyles = () => ({
  footer: {
    borderTop: '1px solid rgb(191, 191, 191)',
    backgroundColor: 'white',
  },
  flexGrow: {
    flex: '1 1 auto',
  },
});

const Footer = () => {
  const classes = useStyles();

  return (
    <Plugin name="ListViewFooter">
      <Template name="footer">
        <TemplateConnector>
          {({ selection, filteredRows, allRows }) => {
            const totalCount = allRows?.length ?? 0;
            const selectedCount = selection?.length ?? 0;
            const filteredCount = filteredRows?.length ?? totalCount;

            return (
              <MuiToolbar sx={classes.footer}>
                {intl.get('board.views.list.tooltips.cards.export.helper_text')}
                <Box sx={classes.flexGrow} />
                {generateNumberOfCardsMessage({
                  totalCount,
                  selectedCount,
                  filteredCount,
                })}
              </MuiToolbar>
            );
          }}
        </TemplateConnector>
      </Template>
    </Plugin>
  );
};

export default Footer;
